const REDIRECT_PARAM = 'rd';

/**
 * Append the post-login redirect target to a url.
 *
 * The value has to be percent encoded. An OAuth2 authorization request is
 * itself a url with a query string, so interpolating it raw truncates it at
 * the first `&` and the client's request is lost.
 */
export function withRedirect(url: string, redirect: string | null): string {
    if (!redirect) {
        return url;
    }

    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}${REDIRECT_PARAM}=${encodeURIComponent(redirect)}`;
}
